export default "__VITE_ASSET__mCiH2mt3__"